import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultipleModalPlaceholderComponent } from './multiple-modal.component';
import { MultipleModalService } from './multiple-modal.indra.service';

// module definition
@NgModule({
	imports: [CommonModule],
	declarations: [MultipleModalPlaceholderComponent],
	exports: [MultipleModalPlaceholderComponent],
	providers: [MultipleModalService]
})
export class MultipleModalModule {
}
